import React from 'react';
import {
  SidePanelComponentProps,
} from 'pages/Dashboard/contexts/sidePanel';
import EOBSummaries from 'pages/Dashboard/pages/Billing/Charges/EOBSummaries';
import {
  EOBSummaryDTO,
} from 'dtos';

type Props = SidePanelComponentProps & {
  eobSummaries?: EOBSummaryDTO[];
};

export default function EOBInfo({ entity, eobSummaries }: Props) {
  const {
    patient,
    visitDate,
  } = entity;

  return (
    <div>
      <EOBSummaries
        eobSummaries={eobSummaries ?? []}
        patient={patient}
        referenceDate={visitDate}
      />
    </div>
  );
}
